<template>
  <main>
    <ul class="cb-slideshow" style="z-index: -2">
      <li><span style="background-image: url(loginfiles/image/login1.jpg)">Image 01</span>
        <div></div>
      </li>
      <li><span style="background-image: url(loginfiles/image/login2.jpg);">Image 02</span>
        <div></div>
      </li>
      <li><span style="background-image: url(loginfiles/image/login3.jpg);">Image 03</span>
        <div></div>
      </li>
      <li><span style="background-image: url(loginfiles/image/login4.jpg);">Image 04</span>
        <div></div>
      </li>
      <li><span style="background-image: url(loginfiles/image/login5.jpg);">Image 05</span>
        <div></div>
      </li>
      <li><span style="background-image: url(loginfiles/image/login1.jpg);">Image 06</span>
        <div></div>
      </li>
    </ul>
    <div class="wms-login-block">
      <div class="wms-login-main">
        <div class="wms-login-form-logo">
          <div class="wms-logo-section p-5">
            <!--                        <img src="loginfiles\image\logo.png" style="width: 251px; height: 60px; display: block !important;">-->
            <span class="logintext">丛林铝业科技（山东）有限责任公司</span>
            <span class="logintext">CONGLIN </span>
          </div>
          <div class="wms-login">
            <div class="wms-login-screen">
              <span class="wms-login-form-title">丛林铝业采购系统</span>
              <div class="selectMode">
                <button :class="mode==1?'active':''" @click="changeMode(1)">业务员登录</button>
                <button :class="mode==2?'active':''" @click="changeMode(2)">供应商登录</button>
              </div>
              <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules"
                       ref="loginForm"
                       label-position="left">
                <el-form-item class="form-group" style="margin-bottom: 10px;" label="用户名" prop="username">
                  <el-input name="username" type="text" ref="user" v-model="loginForm.username"
                            autoComplete="on"
                            placeholder="用户名"/>
                </el-form-item>
                <el-form-item class="form-group" style="margin-bottom: 10px;" label="密码" prop="password"
                              v-show="mode==1">
                  <el-input name="password" class="psd" :type="pwdType"
                            auto-complete="new-password"
                            v-model="loginForm.password"
                            placeholder="密码"></el-input>
                </el-form-item>
                <el-form-item class="form-group verfifyCode" style="margin-bottom: 10px;" label="短信验证码"
                              prop="verfifyCode" v-show="mode==2">
                  <el-input name="verfifyCode" type="text"
                            v-model="loginForm.verfifyCode"
                            placeholder="验证码">
                  </el-input>
                  <el-button type="primary" @click="getCode" :disabled="seconds>-1">
                    {{ seconds > -1 ? `获取验证码(${seconds}s)` : '发送验证码' }}
                  </el-button>
                </el-form-item>
                <el-button v-waves type="primary"
                           style="width:100%;background:#005CA8;font-size: 24px;height: 50px;margin-top: 10px"
                           :loading="loading" @click.native.prevent="handleLogin">
                  登 录
                </el-button>
              </el-form>
            </div>
            <div class="wms-deadline">
              <span>系统到期时间:2026-04-30 8:00:00</span>
              <span class="countDown">倒计时：{{ countDownText }}</span>

            </div>
          </div>
        </div>
        <div class="wms-copyright-text">
          <span>Copyright © 烟台德众网络科技有限公司 2023</span>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import waves from '@/directive/waves'; // 水波纹指令
import {
  mapGetters
} from 'vuex';
import Cookies from 'js-cookie';
import * as login from '@/api/login';

export default {
  name: 'login',
  directives: {
    waves
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('用户名不能为空'));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (!this.loginForm.verfifyCode && value.length <= 0) {
        return callback(new Error('请填写密码'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length <= 0 && !this.loginForm.password) {
        return callback(new Error('请填写验证码'));
      } else {
        callback();
      }
    };
    return {
      mode: '1',
      loginForm: {
        username: '',
        password: '',
        verfifyCode: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          trigger: 'blur',
          validator: validatePass
        }],
        verfifyCode: [{
          trigger: 'blur',
          validator: validateCode
        }]
      },
      loading: false,
      pwdType: 'password',
      seconds: -1,
      timer: null,
      timerCountDown: null,
      countDownText: ''
    };
  },
  computed: {
    ...mapGetters([
      'isIdentityAuth'
    ])
  },
  created() {
    this.countDown();
    this.timerCountDown = setInterval(this.countDown, 1000);
  },
  methods: {
    getApi() {
      return login;
    },
    countDown() {
      const target_time = new Date('2026-04-30 8:00:00');
      // 计算目标时间对象到当前时间的毫秒数
      const reduce_ms = target_time.getTime() - Date.now();
      let day, hour, min, sec;
      if (reduce_ms > -1) {
        day = parseInt(reduce_ms / 1000 / 3600 / 24);
        hour = parseInt(reduce_ms / 1000 / 3600 % 24);
        min = parseInt(reduce_ms / 1000 / 60 % 60);
        sec = Math.round(reduce_ms / 1000 % 60);
      } else {
        day = '0';
        hour = '0';
        min = '0';
        sec = '0';
        clearInterval(this.timerCountDown);
      }
      this.countDownText = day + '天' + hour + '时' + min + '分' + sec + '秒';
    },

    changeMode(val) {
      this.mode = val;
      this.$refs.loginForm.clearValidate();
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    getCode() {
      if (!this.loginForm.username) {
        this.$message({
          message: '请填写用户名',
          type: 'error'
        });
        return;
      }
      if (!this.timer) {
        login.getAuthCode(this.loginForm.username, this.loginForm.password).then((res) => {
          this.seconds = 60;
          // console.log('---', res);
          this.timer = setInterval(() => {
            if (this.seconds > -1) {
              this.seconds--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        });
      }
    },
    handleLogin() {
      // console.log(this.loginForm);
      if (this.mode == 2) {
        this.loginForm.password = '';
      }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch('Login', this.loginForm).then(() => {
            this.loading = false;
            this.seconds = -1;
            clearInterval(this.timer);
            this.timer = null;
            if (this.loginForm.password === '123456') {
              Cookies.set('needChangePsd', true);
            } else {
              Cookies.set('needChangePsd', false);
            }
            this.$router.push({
              path: '/'
            });
          }).catch(() => {
            this.loading = false;
          });
        } else {
          // console.log('error submit!!')
          return false;
        }
      });
    }
  }
};

</script>

<style rel="stylesheet">
body {
  font-family: 'Open Sans', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #F0F0F0;
}

.wms-login-block {
  width: 100%;
  height: 100vh;
  display: flex;
  -ms-opacity: 1;
  opacity: 1;
}

.wms-login-form-logo {
  display: flex;
}

.wms-login-main {
  /* display: flex; */
  width: 824px;
  height: 400px;
  margin: auto;
  align-items: center;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 25px #00000040;
  border-radius: 4px;
}

.wms-logo-section {
  background-color: #005CA8;
  margin: 10px;
  width: 402px;
  height: 380px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  /* margin: 10px;
  width: 402px;
  height: 380px; */
}

/*.wms-logo-section img{
    width: 202px;
    height: 137px;
    padding-right: 0px;
    padding-bottom: 1px;
    padding-top: 0px;
}*/
.wms-login {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: calc(100% - 418px);
}

.wms-deadline {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
}

.wms-login-screen {
  margin: 5px 45px;
}

.selectMode {
  display: flex;
  justify-content: space-around;
  align-content: center;
}

.selectMode button {
  background-color: #fff;
  border: none;
  color: #aeb1b8;
  line-height: 30px;
}

.selectMode button.active {
  color: #000;
  position: relative;
  border-bottom: 2px solid #005CA8;
}

/*
.selectMode button.active::before {
  position: absolute;
  bottom: -10px;
  left: 3px;
  right: 3px;
  color: blue;
  height: 12px;
  content: '';
  width: 50px;
}
*/

.wms-login-screen-failed {
  margin: 20px;
}

.wms-login-form-title {
  font-size: 18px;
  line-height: 4;
  color: #005CA8;
  font-weight: bold;
}

.wms-login-form {
  padding: 0px;
  margin-top: 30px;
  /* margin-left: 1px; */
  /* margin-left: 1px; */
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: left;
  letter-spacing: 0;
  color: #005CA8;
  display: block;
}

.form-group input {
  /* width: 300px; */
  width: 284px;
  height: 30px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #BBBBBB;
  border-radius: 4px;
  padding: 5px 5px 5px 9px;
  font-weight: bold;
  color: #222222;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5rem;
}

.form-group .code {
  display: flex;
}

.verfifyCode button {
  position: absolute;
  bottom: 5px;
  right: 0;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 14px;
  z-index: 999

}

.form-group .wms-password {
  letter-spacing: 3.6px;
}

.wms-btn {
  display: block;
  width: 95px;
  height: 34px;
  background: #005CA8 0% 0% no-repeat padding-box;
  border-radius: 50px;
  margin-top: 30px;
  border: none;
  font-weight: bold;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

img {
  width: 14px;
  height: 11px;
  padding-right: 6px;
  padding-top: 2px;
}

.wms-copyright-text {
  text-align: center;
  font-size: 12px;
  color: #222222;
  margin-top: 20px;
}

.wms-login-failed {
  text-align: center;
}

.wms-login-failed svg {
  width: 100%;
  max-width: 80px;
  margin: 0 auto;
  display: block;
}

.wms-login-failed .wms-login-failed-content {
  margin: 20px 0 22px;
}

.wms-login-failed .wms-login-failed-content span {
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  color: #222222;
  font-weight: 700;
  display: block;
}

.wms-login-failed .btn-try-again {
  width: 121px;
  margin: 0px auto;
  font-weight: 600;
  text-decoration: none;
}
</style>
<style lang="scss">
ul, ol, dl {
  list-style: none
}

.cb-slideshow, .cb-slideshow:after {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0
}

.cb-slideshow:after {
  content: '';
  background: transparent repeat top left
}

.cb-slideshow li span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: transparent;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: none;
  opacity: 0;
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -webkit-animation: imageAnimation 36s linear infinite 0s;
  -moz-animation: imageAnimation 36s linear infinite 0s;
  -o-animation: imageAnimation 36s linear infinite 0s;
  -ms-animation: imageAnimation 36s linear infinite 0s;
  animation: imageAnimation 36s linear infinite 0s
}

.cb-slideshow li div {
  z-index: 1;
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  text-align: center;
  opacity: 0;
  -webkit-animation: titleAnimation 36s linear infinite 0s;
  -moz-animation: titleAnimation 36s linear infinite 0s;
  -o-animation: titleAnimation 36s linear infinite 0s;
  -ms-animation: titleAnimation 36s linear infinite 0s;
  animation: titleAnimation 36s linear infinite 0s
}

.cb-slideshow li div h3 {
  font-family: bebasneueregular, arial narrow, Arial, sans-serif;
  font-size: 240px;
  padding: 0;
  line-height: 200px;
  color: rgba(169, 3, 41, .8)
}

// .cb-slideshow li:nth-child(1) span {  }
.cb-slideshow li:nth-child(2) span {
  -webkit-animation-delay: 6s;
  -moz-animation-delay: 6s;
  -o-animation-delay: 6s;
  -ms-animation-delay: 6s;
  animation-delay: 6s
}

.cb-slideshow li:nth-child(3) span {
  -webkit-animation-delay: 12s;
  -moz-animation-delay: 12s;
  -o-animation-delay: 12s;
  -ms-animation-delay: 12s;
  animation-delay: 12s
}

.cb-slideshow li:nth-child(4) span {
  -webkit-animation-delay: 18s;
  -moz-animation-delay: 18s;
  -o-animation-delay: 18s;
  -ms-animation-delay: 18s;
  animation-delay: 18s
}

.cb-slideshow li:nth-child(5) span {
  -webkit-animation-delay: 24s;
  -moz-animation-delay: 24s;
  -o-animation-delay: 24s;
  -ms-animation-delay: 24s;
  animation-delay: 24s
}

.cb-slideshow li:nth-child(6) span {
  -webkit-animation-delay: 30s;
  -moz-animation-delay: 30s;
  -o-animation-delay: 30s;
  -ms-animation-delay: 30s;
  animation-delay: 30s
}

.cb-slideshow li:nth-child(2) div {
  -webkit-animation-delay: 6s;
  -moz-animation-delay: 6s;
  -o-animation-delay: 6s;
  -ms-animation-delay: 6s;
  animation-delay: 6s
}

.cb-slideshow li:nth-child(3) div {
  -webkit-animation-delay: 12s;
  -moz-animation-delay: 12s;
  -o-animation-delay: 12s;
  -ms-animation-delay: 12s;
  animation-delay: 12s
}

.cb-slideshow li:nth-child(4) div {
  -webkit-animation-delay: 18s;
  -moz-animation-delay: 18s;
  -o-animation-delay: 18s;
  -ms-animation-delay: 18s;
  animation-delay: 18s
}

.cb-slideshow li:nth-child(5) div {
  -webkit-animation-delay: 24s;
  -moz-animation-delay: 24s;
  -o-animation-delay: 24s;
  -ms-animation-delay: 24s;
  animation-delay: 24s
}

.cb-slideshow li:nth-child(6) div {
  -webkit-animation-delay: 30s;
  -moz-animation-delay: 30s;
  -o-animation-delay: 30s;
  -ms-animation-delay: 30s;
  animation-delay: 30s
}

.logintext {
  display: block;
  font-family: 微软雅黑;
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 10px;
}

@-webkit-keyframes imageAnimation {
  0% {
    opacity: 0;
    -webkit-animation-timing-function: ease-in
  }
  8% {
    opacity: 0.1;
    -webkit-transform: scale(1.05);
    -webkit-animation-timing-function: ease-out
  }
  17% {
    opacity: 0.2;
    -webkit-transform: scale(1.1)
  }
  25% {
    opacity: 0;
    -webkit-transform: scale(1.1)
  }
  100% {
    opacity: 0
  }
}

@-moz-keyframes imageAnimation {
  0% {
    opacity: 0;
    -moz-animation-timing-function: ease-in
  }
  8% {
    opacity: 0.1;
    -moz-transform: scale(1.05);
    -moz-animation-timing-function: ease-out
  }
  17% {
    opacity: 0.2;
    -moz-transform: scale(1.1)
  }
  25% {
    opacity: 0;
    -moz-transform: scale(1.1)
  }
  100% {
    opacity: 0
  }
}

@-o-keyframes imageAnimation {
  0% {
    opacity: 0;
    -o-animation-timing-function: ease-in
  }
  8% {
    opacity: 0.1;
    -o-transform: scale(1.05);
    -o-animation-timing-function: ease-out
  }
  17% {
    opacity: 0.2;
    -o-transform: scale(1.1)
  }
  25% {
    opacity: 0;
    -o-transform: scale(1.1)
  }
  100% {
    opacity: 0
  }
}

@-ms-keyframes imageAnimation {
  0% {
    opacity: 0;
    -ms-animation-timing-function: ease-in
  }
  8% {
    opacity: 0.1;
    -ms-transform: scale(1.05);
    -ms-animation-timing-function: ease-out
  }
  17% {
    opacity: 0.2;
    -ms-transform: scale(1.1)
  }
  25% {
    opacity: 0;
    -ms-transform: scale(1.1)
  }
  100% {
    opacity: 0
  }
}

@keyframes imageAnimation {
  0% {
    opacity: 0;
    animation-timing-function: ease-in
  }
  8% {
    opacity: 0.1;
    transform: scale(1.05);
    animation-timing-function: ease-out
  }
  17% {
    opacity: 0.2;
    transform: scale(1.1)
  }
  25% {
    opacity: 0;
    transform: scale(1.1)
  }
  100% {
    opacity: 0
  }
}

@-webkit-keyframes titleAnimation {
  0% {
    opacity: 0;
    -webkit-transform: translateY(200px)
  }
  8% {
    opacity: 0.1;
    -webkit-transform: translateY(0px)
  }
  17% {
    opacity: 0.2;
    -webkit-transform: scale(1)
  }
  19% {
    opacity: 0
  }
  25% {
    opacity: 0;
    -webkit-transform: scale(10)
  }
  100% {
    opacity: 0
  }
}

@-moz-keyframes titleAnimation {
  0% {
    opacity: 0;
    -moz-transform: translateY(200px)
  }
  8% {
    opacity: 0.1;
    -moz-transform: translateY(0px)
  }
  17% {
    opacity: 0.2;
    -moz-transform: scale(1)
  }
  19% {
    opacity: 0
  }
  25% {
    opacity: 0;
    -moz-transform: scale(10)
  }
  100% {
    opacity: 0
  }
}

@-o-keyframes titleAnimation {
  0% {
    opacity: 0;
    -o-transform: translateY(200px)
  }
  8% {
    opacity: 0.1;
    -o-transform: translateY(0px)
  }
  17% {
    opacity: 0.2;
    -o-transform: scale(1)
  }
  19% {
    opacity: 0
  }
  25% {
    opacity: 0;
    -o-transform: scale(10)
  }
  100% {
    opacity: 0
  }
}

@-ms-keyframes titleAnimation {
  0% {
    opacity: 0;
    -ms-transform: translateY(200px)
  }
  8% {
    opacity: 0.1;
    -ms-transform: translateY(0px)
  }
  17% {
    opacity: 0.2;
    -ms-transform: scale(1)
  }
  19% {
    opacity: 0
  }
  25% {
    opacity: 0;
    -webkit-transform: scale(10)
  }
  100% {
    opacity: 0
  }
}

@keyframes titleAnimation {
  0% {
    opacity: 0;
    transform: translateY(200px)
  }
  8% {
    opacity: 0.1;
    transform: translateY(0px)
  }
  17% {
    opacity: 0.2;
    transform: scale(1)
  }
  19% {
    opacity: 0
  }
  25% {
    opacity: 0;
    transform: scale(10)
  }
  100% {
    opacity: 0
  }
}

.no-cssanimations .cb-slideshow li span {
  opacity: 1
}

@media screen and (max-width: 1140px) {
  .cb-slideshow li div h3 {
    font-size: 100px
  }
}

@media screen and (max-width: 600px) {
  .cb-slideshow li div h3 {
    font-size: 50px
  }
}

</style>

